import React from 'react';

import { formatCount, formatDateTime, formatRequestId } from '../utils/format';

export default function DashboardHero({ latestReport, reportCount, submitting, totalRows }) {
  return (
    <section className="hero">
      <div className="hero__content">
        <span className="hero__eyebrow">Excel Report Workspace</span>
        <h1>Generate cleaner campaign reports and download them as real Excel files.</h1>
        <p>
          Upload a source sheet, simulate delivery states, and keep each generated workbook in a
          faster local report library.
        </p>
        <div className="hero__chips">
          <span className="chip">Direct .xlsx download</span>
          <span className="chip">Local report cache</span>
          <span className="chip">Responsive dashboard</span>
        </div>
      </div>

      <div className="hero__stats">
        <article className="stat-card">
          <span className="stat-card__label">Reports generated</span>
          <strong>{formatCount(reportCount)}</strong>
          <span className="stat-card__meta">Saved locally for quick downloads</span>
        </article>

        <article className="stat-card">
          <span className="stat-card__label">Rows processed</span>
          <strong>{formatCount(totalRows)}</strong>
          <span className="stat-card__meta">Across all stored workbooks</span>
        </article>

        <article className="stat-card stat-card--wide">
          <span className="stat-card__label">Latest request</span>
          <strong>{latestReport ? formatRequestId(latestReport.id) : 'Waiting for first upload'}</strong>
          <span className="stat-card__meta">
            {submitting
              ? 'Generating a new workbook right now.'
              : latestReport
                ? `${formatDateTime(latestReport.createdAt)} | ${formatCount(latestReport.count)} rows`
                : 'Upload an Excel file to populate this panel.'}
          </span>
        </article>
      </div>
    </section>
  );
}
